import axios from "axios";
import { environment } from "../../environment";
import moment from "moment/moment";

export const SessionsService = () => {

    const updateSession = async (session: any) => {

        const path = `${environment.contentUrl}sessions`;
        await updateSessionInSFDC(session);

        const res: any = await axios.patch(path, session, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        return res;
    }

    const updateSessionOrder = async (sessionId: string, order: number) => {
        const path = environment.contentUrl + 'sessions/order';
        const res: any = await axios.patch(path, { sessionId, order }, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        return res;
    }


    const updateSessionInSFDC = async (session: any) => {

        try {
            const path = environment.authUrl + "sf/update";
            const data = {
                update: {},
                subject: 'Program_Tier_3__c'
            };
            data.update = {
                Id: session.sfSessionId,
                HN_Session_title__c: session.sessionTitle,
                HN_Session_desc__c: session.sessionDescription,
                Class_Start_Date__c: session.startDate ? moment(session.startDate).format('YYYY-MM-DD') : null,
                Class_Start_Time__c: session.startTime ? moment(session.startTime, ["HH:mm"]).format("h:mm A") : null,
                Class_End_Time__c: session.endTime ? moment(session.endTime, ["HH:mm"]).format("h:mm A") : null,
                Zoom_URL__c: session.zoomUrl,
                Registration_URL__c: session.registrationURL,
                Room__c: session.room,
                HN_Id__c: session._id,
                HN_Privacy__c: session.sessionPrivacy,
                HN_Session_Type__c: session.sessionType,
                Class_Reminder__c: session.classReminder
            };

            const res = axios.post(path, data)
                .then((response) => {
                    console.log('success update session in sfdc');
                }, (error) => {
                    console.log(error);
                });
            return res;
        } catch (err) {
            throw err;
        }
    }

    const getSessionItem = async (id: any) => {
        try {
            const path = environment.contentUrl + 'session/item/' + id;
            const res = await axios.get(path);
            return res?.data;
        } catch (err) {
            throw err
        }
    }

    const getSessionsListByTitle = async (title: any) => {
        try {
            const path = environment.contentUrl + 'session/searchtitle/' + title;
            const res = await axios.get(path);
            return res?.data;
        } catch (err) {
            throw err
        }
    }

    const getSessionItemsByEventId = async (ids: []) => {
        try {
            const path = environment.contentUrl + 'session/event_items/' + ids;
            const res = await axios.get(path);
            return res?.data;
        } catch (err) {
            throw err
        }
    }

    const deleteSessionFromEvent = async (eventId: string) => {
        console.log('SessionsService: Initiating session deletion for ID:', eventId);
        try {
            const response = await axios.delete(`${environment.authUrl}deleteDuplicateSessions/${eventId}`);
            console.log('SessionsService: Session deletion successful', response.data);
            return response.data;
        } catch (error) {
            console.error('SessionsService: Error deleting session:', error);
            throw error;
        }
    }

    return {
        updateSession,
        updateSessionOrder,
        updateSessionInSFDC,
        getSessionItem,
        getSessionItemsByEventId,
        getSessionsListByTitle,
        deleteSessionFromEvent
    }
}






